import React from "react";
import { useState, useMemo } from "react";
import { Button } from "react-bootstrap";
import FormModal from "../FormModal";
import Activities from "../Activities";
import EntityValidations from "./EntityValidations";
import InHouseStatus from "./InHouseStatus";
import WhollyOwnedApplications from "../WhollyOwnedApplications/WhollyOwnedApplications";
import Designations from "../Designations/Designations";
import CreateDesignationButton from "../Designations/CreateDesignationButton";
import Pharmacies from "./Pharmacies";
import EffectiveDates from "../EffectiveDates/EffectiveDates";
import CreateEffectiveDate from "../EffectiveDates/CreateEffectiveDate";
import { Form, Tab, Tabs } from "react-bootstrap";
import Users from "../Users/Users";
import ChildSites from "./ChildSites";
import Entities from "./Entities";
import Tpas from "../TPAs";

const Entity = (props) => {
  const [showInviteUserModal, setShowInviteUserModal] = useState(false);
  const [hideActions, setHideActions] = useState(true);

  return (
    <React.Fragment>
      {props.entity.designation_permitted_status == "has_inhouse_pharmacy" ||
      props.in_house_designations_exist ? (
        <InHouseStatus
          entity={props.entity}
          in_house_designations_exist={props.in_house_designations_exist}
        />
      ) : null}
      <Tabs
        defaultActiveKey={props.params.tab || "activities"}
        id="covered_entity_tabs"
        className="mb-3"
      >
        <Tab
          eventKey="activities"
          title={
            <>
              <i className="fa fa-list"></i> Activity
            </>
          }
        >
          <Activities activities_path={props.activities_path} />
        </Tab>
        <Tab
          eventKey="pharmacies"
          title={
            <>
              <i className="fa fa-prescription-bottle"></i> Pharmacies{" "}
              <span className="badge bg-light text-dark">{props.pharmacies_count}</span>
            </>
          }
        >
          <Pharmacies pharmacies_path={props.pharmacies_path} />
        </Tab>
        <Tab
          eventKey="designations"
          title={
            <>
              <i className="fa fa-map-pin"></i> Designations{" "}
              <span className="badge bg-light text-dark">{props.designations_count}</span>
            </>
          }
        >
          {props.can_update_designation ? (
            <div className="mb-3">
              <small className="text-muted">Want to create a new designation?</small>
              <CreateDesignationButton
                manufacturers={props.designation_config.manufacturers}
                designation_kinds={props.designation_config.designation_kinds}
                id_340b={props.entity.id_340b}
                create_designation_path={props.designation_config.create_designation_path}
              />
            </div>
          ) : null}
          <Designations
            hide_count="true"
            designations_path={props.designations_path}
            flag_options={props.designation_config.flag_options}
            can_update={props.can_update_designation}
            can_assign={props.can_assign_designation}
          />
        </Tab>
        {props.can_view_users ? (
          <Tab
            eventKey="users"
            title={
              <>
                <i className="fa fa-user-plus"></i> Users{" "}
                <span className="badge bg-light text-dark">{props.users_count}</span>
              </>
            }
          >
            {props.canInviteUser ? (
              <div className="mb-3">
                <small className="text-muted">
                  Would you like to invite a new or existing user to this covered entity?
                </small>
                <button
                  className="btn btn-primary ms-2 btn-sm"
                  onClick={() => {
                    setShowInviteUserModal(true);
                  }}
                >
                  <i className="fa fa-user me-1"></i>
                  Invite User/Grant Access
                </button>
              </div>
            ) : null}
            <Users
              users_path={props.users_path}
              permittedRoleUpdateObj={props.permittedRoleUpdateObj}
              orderedRoles={props.orderedRoles}
              canUpdateBasicFields={props.canUpdateBasicUserFields}
              canGrantEntityAccess={props.canGrantEntityAccess}
              espUrl={props.envESPAppDomain}
              hide_count="true"
              id_340b={props.entity.id_340b}
              canUpdateUserEntity={props.canUpdateUserEntity}
            />
          </Tab>
        ) : null}
        {props.canViewEntityValidations ? (
          <Tab
            eventKey="validations"
            title={
              <>
                <i className="fa fa-clipboard-check"></i> Validations{" "}
                <span className="badge bg-light text-dark">{props.entity_validations.length}</span>
              </>
            }
          >
            <EntityValidations
              entity_validations={props.entity_validations}
              entity={props.entity}
              users={props.ce_users}
              can_create={props.can_create_entity_validation}
              can_send_manually_approved_email={props.can_send_manually_approved_email}
            />
          </Tab>
        ) : null}
        {props.wholly_owned_applications_count > 0 ? (
          <Tab
            eventKey="wo_applications"
            title={
              <>
                <i className="fa fa-file-lines"></i> WO Applications{" "}
                <span className="badge bg-light text-dark">
                  {props.wholly_owned_applications_count}
                </span>
              </>
            }
          >
            <WhollyOwnedApplications
              applications_path={props.wholly_owned_applications_path}
              hide_count="true"
            />
          </Tab>
        ) : null}
        <Tab
          eventKey="effective_dates"
          title={
            <>
              <i className="fa fa-calendar-check"></i> Effective Dates{" "}
              <span className="badge bg-light text-dark">{props.effective_dates_count}</span>
            </>
          }
        >
          {props.can_manage_effective_date ? (
            <p>
              Want to add a new effective date?
              <CreateEffectiveDate
                manufacturers={props.manufacturers}
                manufacturer_networks={props.manufacturer_networks}
                id_340b={props.entity.id_340b}
              />
            </p>
          ) : null}
          <EffectiveDates
            effective_dates_path={props.effective_dates_path}
            manufacturer_networks={props.manufacturer_networks}
            covered_entity={props.entity}
            manufacturers={props.manufacturers}
            hide_count="true"
            can_manage={props.can_manage_effective_date}
          />
        </Tab>
        {(!props.entity.child_site && !props.entity.parent_id_340b) ||
        (props.entity.child_site === false && !props.entity.parent_id_340b) ? (
          <Tab
            eventKey="tpas"
            title={
              <>
                <i className="fa fa-building-circle-arrow-right"></i> TPAs
                <span className="badge bg-light text-dark">{props.tpas?.length ?? "0"}</span>
              </>
            }
          >
            <Tpas tpas={props.tpas} />
          </Tab>
        ) : null}
        {(!props.entity.child_site && !props.entity.parent_id_340b) ||
        (props.entity.child_site === false && !props.entity.parent_id_340b) ? (
          <Tab
            eventKey="child_sites"
            title={
              <>
                <i className="fa fa-th-list"></i> Child Sites
              </>
            }
          >
            <ChildSites child_sites={props.child_sites} current_parent_site={props.entity} />
          </Tab>
        ) : null}
      </Tabs>
      <FormModal
        show={showInviteUserModal}
        title="Invite User/Grant Access"
        hideActions={hideActions}
        buttonText="Submit"
        buttonType="primary"
        modalId="invite_user_modal"
        fields={
          <InviteUserGrantAccessForm
            espUrl={props.envESPAppDomain}
            id_340b={props.entity.id_340b}
            entityId={props.entity.id}
            setHideActions={setHideActions}
          />
        }
        action={`/entities/${props.entity.id_340b}/users`}
        dismiss={() => {
          setShowInviteUserModal(false);
        }}
      />
    </React.Fragment>
  );
};

const InviteUserGrantAccessForm = ({ espUrl, id_340b, entityId, setHideActions }) => {
  const [email, setEmail] = useState("");
  const [user, setUser] = useState(null);
  const [invalidEmailError, setInvalidEmailError] = useState("");
  const [showInviteUserFormFields, setShowInviteUserFormFields] = useState(false);
  const [emailFound, setEmailFound] = useState(false);

  const checkEmail = async () => {
    try {
      const response = await fetch(`/entities/${entityId}/users/check_email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
        },
        body: JSON.stringify({ email }),
      });

      if (response.status === 422) {
        setInvalidEmailError("Please enter a valid email");
        setShowInviteUserFormFields(false);
        setEmailFound(false);
        setHideActions(true);
        return;
      }

      const data = await response.json();

      setInvalidEmailError("");
      setShowInviteUserFormFields(true);
      setEmailFound(data.found);
      setHideActions(false);
      setUser(data.user);
    } catch (error) {
      console.error(`Error fetching data: ${error}`);
    }
  };

  return (
    <React.Fragment>
      <p>
        <small className="text-danger">* Required</small>
      </p>
      <p>
        <small>Enter the user's email to see if they are an existing or new user.</small>
      </p>
      <Form.Group className="mb-3" controlId="email">
        <Form.Label>
          Email <small className="text-danger">*</small>
        </Form.Label>
        <Form.Control
          required
          name="user[email]"
          placeholder="Enter email"
          onChange={(e) => setEmail(e.target.value)}
        />
      </Form.Group>
      {invalidEmailError && <small className="text-danger mt-1">{invalidEmailError}</small>}
      <div className="d-flex justify-content-end">
        <Button
          className="btn-sm btn-secondary bg-light text-dark rounded-4"
          disabled={!email.trim()}
          onClick={() => checkEmail()}
        >
          Check email
        </Button>
      </div>
      <p className="mt-2">
        <small className="text-muted">
          <b>Note:</b> An entity validation will be created for this email domain, if it does not
          already exist. Please ensure email is correct.
        </small>
      </p>
      {showInviteUserFormFields ? (
        <>
          {emailFound ? (
            <>
              {user.activation_state === "pending" ? (
                <>
                  {user.full_name} has a pending activation state for {espUrl}. To grant them access
                  to 340B ID {`${id_340b}`}, confirm their email address and select their user role.
                  Then, click "Submit". Once they complete the onboarding steps, they will have
                  access to this entity.
                </>
              ) : (
                <>
                  {user.pending_entities.length > 0 ? (
                    <>
                      {user.full_name} has pending user-entity access to{" "}
                      {user.pending_entities.join(", ")}. To grant them access to 340B ID{" "}
                      {`${id_340b}`}, confirm their email address and select their user role. Then,
                      click "Submit".
                    </>
                  ) : (
                    <>
                      {user.full_name} is an existing user to {espUrl}. To grant them access to 340B
                      ID {`${id_340b}`}, confirm their email address and select their user role.
                      Then, click "Submit".
                    </>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              No existing users were found with the email address provided. Enter in the information
              below to invite user to {espUrl} and grant them access to 340B ID {`${id_340b}`}. Once
              they complete the onboarding steps and log in, they will have access to this entity.
            </>
          )}
          <Form.Group className="mb-3 mt-3" controlId="email_confirmation">
            <Form.Label>
              Confirm Email <small className="text-danger">*</small>
            </Form.Label>
            <Form.Control required name="user[email_confirmation]" placeholder="Confirm email" />
          </Form.Group>
          {emailFound ? null : (
            <>
              <Form.Group className="mb-3" controlId="first_name">
                <Form.Label>
                  First Name <small className="text-danger">*</small>
                </Form.Label>
                <Form.Control required name="user[first_name]" placeholder="Enter first name..." />
              </Form.Group>
              <Form.Group className="mb-3" controlId="last_name">
                <Form.Label>
                  Last Name <small className="text-danger">*</small>
                </Form.Label>
                <Form.Control required name="user[last_name]" placeholder="Enter last name..." />
              </Form.Group>
            </>
          )}
          <Form.Group className="mb-3" controlId="role">
            <Form.Label>
              Role <small className="text-danger">*</small>
            </Form.Label>
            <Form.Select required name="user[role]" as="select">
              <option value="user">User</option>
              <option value="admin">Admin</option>
            </Form.Select>
          </Form.Group>
        </>
      ) : null}
    </React.Fragment>
  );
};

export default Entity;
